"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideDataSecurityApplicationById = void 0;
const _types_1 = require("../../@types/index.js");
const patchDataSecurityApplicationById_1 = require("./patchDataSecurityApplicationById.js");
const hideDataSecurityApplicationById = (request) => (0, patchDataSecurityApplicationById_1.patchDataSecurityApplicationById)(Object.assign(Object.assign({}, request), { status: _types_1.DataSecurityApplicationStatus.Deleted }));
exports.hideDataSecurityApplicationById = hideDataSecurityApplicationById;
//# sourceMappingURL=hideDataSecurityApplicationById.js.map